<template lang="pug">
  div(v-if="entity=='ReferenceMatrix'")
    v-container(fluid)
      v-row(justify-center, style="overflow: hidden")
        v-col.px-0(cols="12")
          g-btn.h8(
            color="primary"
            @click="emitter('downloadFile')"
          ) {{ $t('fileControl.downloadFile') }}
  div(v-else)
    .my-1
      v-list-item
        v-list-item-content
          v-list-item-title
            v-row(align-center)
              v-col.text-truncate {{fileName}}
        v-list-item-icon.ma-auto
          v-row
            template(v-if="uploadMode")
              v-icon(@click="emitter('removeFile')") mdi-close
            template(v-else)
              v-icon.mr-4(@click="emitter('downloadFile')") mdi-download
              v-icon(@click="emitter('deleteFile')") mdi-delete
</template>

<script>
export default {
  props: {
    value: {},
    entity: "",
    errorMessages: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    uploadMode: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    types: ['Commercial Invoice', 'Bill of Lading', 'Packing List', 'Others'],
  }),

  watch: {
  },

  computed: {
    file() {
      return this.value.file;
    },
    fileName() {
      return this.value.fileName;
    },
    type: {
      get() {
        return this.value.fileType;
      },
      set(val) {
        this.$emit('input', {...this.value, fileType: val});
      },
    },
  },

  methods: {
    emitter(val) {
      this.$emit(val);
    },
  },
}
</script>
